module.exports = __webpack_public_path__ + "static/media/menu-close.6590a5bf.svg";